import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IncidentGroupTypeModel } from '../models/incident-group-type.model';
import { IncidentTypeModel } from '../models/incident-type.model';
import { MissingRequirementsDocumentModel } from '../models/missing-requirements-document.model';

@Injectable()
export class EnumDataService {

    private incidentTypeSubject = new BehaviorSubject<IncidentTypeModel[]>(null);
    private incidentGroupTypeSubject = new BehaviorSubject<IncidentGroupTypeModel[]>(null);
    private missingRequirementDocumentModelSubject = new BehaviorSubject<MissingRequirementsDocumentModel[]>(null);

    public sendIncidentTypeData(incidentTypeData: IncidentTypeModel[]) {
        this.incidentTypeSubject.next(incidentTypeData);
    }

    public getIncidentTypeData(): Observable<IncidentTypeModel[]> {
        return this.incidentTypeSubject.asObservable();
    }

    public getIncidentTypeDataComplete() {
        return this.incidentTypeSubject;
    }

    public sendIncidentGroupTypeData(incidentGroupTypeData: IncidentGroupTypeModel[]) {
        return this.incidentGroupTypeSubject.next(incidentGroupTypeData);
    }

    public getIncidentGroupTypeData(): Observable<IncidentGroupTypeModel[]> {
        return this.incidentGroupTypeSubject.asObservable();
    }

    public getIncidentGroupTypeDataComplete() {
        return this.incidentGroupTypeSubject;
    }

    public sendMissingRequirementDocumentData(missingRequirementData: MissingRequirementsDocumentModel[]) {
        return this.missingRequirementDocumentModelSubject.next(missingRequirementData);
    }

    public getMissingRequirementDocumentData(): Observable<MissingRequirementsDocumentModel[]> {
        return this.missingRequirementDocumentModelSubject.asObservable();
    }

}
